import { render } from "./WordGame.vue?vue&type=template&id=4d52d846&scoped=true"
import script from "./WordGame.vue?vue&type=script&lang=ts"
export * from "./WordGame.vue?vue&type=script&lang=ts"

import "./WordGame.vue?vue&type=style&index=0&id=4d52d846&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4d52d846"

export default script